import React, { useEffect, useState } from "react";
import { dep } from "./Depreciation.js";
import {
  Row,
  Button,
  Input,
  Col,
  Form,
  Select,
  TreeSelect,
  Switch,
  Divider,
  Spin,
  Card,
  Table,
  Upload,
  InputNumber,
} from "antd";
import { useClient } from "../../Context/ClientContext";
import FixedAssetsServiceNew, {
  appendObjectToFormData,
} from "../../Services/FixedAssetsServiceNew";
import {
  DeleteOutlined,
  EditOutlined,
  LoadingOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { dayjs } from "../../../Utilities/dayjs";
import { handleInputFocus, Utils } from "../../../Utilities/Utils";
import { SearchLedgerByGroupsTypes } from "../../Services/LedgerService";
import { notificationContext } from "../../Common/PageRoute";

import { ColumnsType } from "antd/es/table/InternalTable.js";
import AssetInvoiceDetail from "./AssetInvoiceDetail";
import { useLocation, useNavigate } from "react-router-dom";
import EntryLevelKeys from "../../Common/EntryLevelKeys";
// import { ConfirmationModal } from "../../Common/ConfirmationModal.js";
// import DocumentPreview from "../../Common/DocumentPreview.js";
// import DocumentPreview from "../../../CapsitechAccountsComponents/Common/DocumentPreview.js";
import { ConfirmationModal } from "../../Common/ConfirmationModal";
import ChartofAccountServicesNew from "../../../CapsitechAccountsComponents/Services/ChartofAccountServicesNew";
import {
  ITCEligibility_Type,
  VoucherMode,
} from "../../Services/VoucherServices";
import AddGroup from "../Master/Group/AddGroup";

export enum PmtMethod {
  bank,
  cash,
  fullCredit,
  partialCredit,
}

export enum CalcMethod {
  WrittenDownValue,
  StraightLine,
}

export enum AssetPurType {
  NewPurchase,
  OldPurchase,
  All,
}
export interface InvoiceDetail {
  key: number;
  date: string;
  voucherDate: string;
  invNumber: string;
  taxCredit: boolean;
  price: number;
  gst: {};
  purPayMethod: PmtMethod;
  partiallyPaidAmount: number;
  purPayDate: string;
  purPaymentLedger: string;
  purPartyLedger: string;
  purPayRef: string;
  qty: number;
  childAssetDetail: ChildAsset[];
  voucherRefs: any;
  totalValue?: number;
}
export interface ChildAsset {
  key: number;
  childAssetNumber: string;
  childAssetName?: string;
  childAssetPrice?: number;
  location?: string;
  model?: string;
  identityCode?: string;
  warrantyExpDate?: string | undefined;
  lifeCycleDuration?: number;
  price?: number;
  residualValue?: number;
  depreciationStartDate?: string | undefined;
  description?: string;
}

const AssetModel = ({ setOpenAssetModal, isNewAdd, oldPurchase }: any) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  // const [childform] = Form.useForm();
  const location = useLocation();
  const [isDepreciable, setDepreciable] = React.useState<boolean>(true);
  const [singleAssetType, setSingleAssetType] = React.useState<boolean>(true);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [assetAvailable, setAssetAvailable] = useState<boolean>(false);
  const [groupListTrigger, setGroupListTrigger] = useState<boolean>(false);
  const [addGroupVal, setAddGropVal] = React.useState<any>();
  const [assetsList, setAssetsList] = useState<any>([]);
  const [payLedgers, setPayLedgers] = useState<any>([]);
  const [fixedAssetsGroups, setFixedAssetsGroups] = useState<any>([]);
  const [categoryValue, setCategoryValue] = useState<string>("");
  const [voucherDate, setVoucherDate] = useState<string>(dayjs().toISOString());
  const [depMethod, setDepMethod] = useState<CalcMethod>(
    CalcMethod.WrittenDownValue
  );
  const [invoiceDetaildata, setInvoiceDetail] = React.useState<InvoiceDetail[]>(
    []
  );
  const { currentClient, companySettings } = useClient();
  const { openNotification } = React.useContext(notificationContext);
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);
  const [oldPurchaseType, setOldPurchaseType] = useState<boolean>(
    oldPurchase ? true : false
  );
  // const gstOption = companySettings?.setting?.gstDetails?.gst;
  const gstOption = companySettings?.gsts;
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const [openModel, setOpenModel] = React.useState<{
    type: string;
    param: any;
  }>({
    type: "",
    param: "",
  });
  const [deleteUploadId, setDeleteUploadId] = React.useState<string[]>([]);
  const [previewImage, setPreviewImage] = React.useState<{
    isBaseConvert: boolean;
    path: any;
  }>({ isBaseConvert: false, path: "" });
  const [groupDropdownloading, setGroupDropdownloading] = React.useState(false);

  const editAssetId: string = isNewAdd ? undefined : location?.state?.data?.id;

  const [confirmation, setConfirmation] = useState<boolean>(false);
  const [val, setVal] = React.useState<any[]>([]);

  useEffect(() => {
    const getGroupFixedAssets = async (clientId: String) => {
      if (clientId) {
        // ------- Get Fixed Assets Groups APi ------
        setGroupDropdownloading(true);
        // await ReportsServiceNew.getGroupHierarchy(
        //   currentClient?.id!,
        //   undefined,
        //   undefined,
        //   "",
        //   GroupList_Type.All,
        //   SearchLedgerByGroupsTypes.FixedAssets
        // )
        await ChartofAccountServicesNew.getGroupList(
          currentClient?.id!,
          currentClient?.productModule,
          "",
          "",
          "",
          "",
          SearchLedgerByGroupsTypes.FixedAssets
        )
          .then((res: any) => {
            if (res?.items?.length > 0) {
              setFixedAssetsGroups(GetGroupList(res?.items));
              setGroupDropdownloading(false);
              if (!form.getFieldValue("group"))
                form.setFieldValue("group", res?.items[0]?.id);
            } else {
              setGroupDropdownloading(false);
            }
          })
          .catch((err: any) => {
            console.error("error......", err?.message);
            setGroupDropdownloading(false);
          });
      }
    };
    getGroupFixedAssets(currentClient?.id!);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, groupListTrigger]); //, searchSupplier.search]);

  const GetGroupList = (GrpList: any[]) => {
    return GrpList?.map((itm: any) => {
      const list: any = {
        // key: itm?.id,
        id: itm?.id,
        parent: itm?.parent,
        value: itm?.id,
        title: itm?.group_Name,
        // title: itm?.name,
        // nature: itm?.nature,
        // statement: itm?.statement,
      };
      if (itm?.children?.length > 0) {
        list.children = GetGroupList([...itm?.children]);
      }
      return list;
    });
  };

  function searchCategory(CategoryData: any, searchId: string): any {
    for (const child of CategoryData) {
      if (child.Id === searchId) {
        return child;
      }
      if (child.Children.length > 0) {
        const result = searchCategory(child.Children, searchId);
        if (result) {
          return result;
        }
      }
    }
  }

  const SetDepRatenLife = (SelCategory: string, SelDepMethod: CalcMethod) => {
    if (SelCategory !== "") {
      const depFilterReco = searchCategory(dep, SelCategory);
      form.setFieldValue("lifeCycleDuration", depFilterReco?.Life);
      form.setFieldValue("depMethod", SelDepMethod);
      if (SelDepMethod === CalcMethod.WrittenDownValue) {
        form.setFieldValue(
          "depRate",
          Math.round(depFilterReco?.WDVRate * 100) / 100
        );
      } else {
        form.setFieldValue(
          "depRate",
          Math.round((100 / depFilterReco?.Life) * 100) / 100
        );
      }
    }
  };

  const handleSLMDepRate = (val: any) => {
    if (depMethod === CalcMethod.StraightLine) {
      form.setFieldValue("depRate", Math.round((100 / val) * 100) / 100);
    } else {
      return;
    }
  };

  const onAssetDepMethodChange = (selValue: CalcMethod) => {
    setDepMethod(selValue);
    SetDepRatenLife(categoryValue, selValue);
  };

  function onAssetCategoryChange(selValue: string) {
    setCategoryValue(selValue);
    SetDepRatenLife(selValue, depMethod);
  }

  const GetCategoryList = (DepList: any[]) => {
    return DepList?.map((itm: any) => {
      const list: any = {
        key: itm.Id,
        value: itm.Id,
        title: itm.Title,
      };
      if (itm.Children.length > 0) {
        list.children = GetCategoryList([...itm.Children]);
      }
      return list;
    });
  };
  const AssetCategoryOptions = GetCategoryList(dep);

  const getVoucherTitle = companySettings?.setting?.vouchersSettings?.find(
    (x: any) => x?.title === "ASSET"
  );

  useEffect(() => {
    if (!editAssetId) {
      setLoading(true);
      FixedAssetsServiceNew.getAssetMaxNo(
        currentClient?.id!,
        voucherDate,
        getVoucherTitle?.title
      )
        .then((res) => {
          form.setFieldValue("number", res?.result);
          form.setFieldValue("date", dayjs());
          setLoading(false);
        })
        .catch((err: any) => {
          setLoading(false);
          openNotification("error", err.message);
          console.error(err.message);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);

  const onSubmit = () => {
    form
      .validateFields()
      .then((values: any) => {
        // let formValues = { ...values };
        // let formData = new FormData();
        // appendObjectToFormData(formData, formValues);
        // appendObjectToFormData(formData, { invoiceDetail: invoiceDetaildata });

        if (invoiceDetaildata?.length > 0) {
          setSaveButtonLoading(true);
          if (singleAssetType) {
            invoiceDetaildata[0].childAssetDetail[0].childAssetName =
              values?.name;
          }
          const asset = {
            ...values,
            // date: values.date,
            mode: oldPurchaseType ? VoucherMode.Opening : VoucherMode.Normal,
            isDepreciable: isDepreciable,
            invoiceDetail: invoiceDetaildata,
            deleteUploadId: deleteUploadId,
          };
          FixedAssetsServiceNew.PostFixedAssets(
            currentClient?.id!,
            asset,
            editAssetId
          )
            .then((res: any) => {
              if (res.result) {
                openNotification(
                  "success",
                  `Asset ${
                    editAssetId
                      ? "updated successfully."
                      : "added successfully."
                  }`
                );
                // setIsModalOpen(false);
                // setTrigger((x) => !x);
                form.resetFields();
                setSaveButtonLoading(false);
                navigate(
                  `/billing/clients/${currentClient?.id}/asset/fixedAsset`
                );
              } else {
                openNotification("error", res.message);
                setSaveButtonLoading(false);
              }
            })
            .catch((error) => {
              openNotification("error", error);
              setSaveButtonLoading(false);
            });
        } else {
          openNotification("error", `Please Add Purchase Detail`);
        }
      })

      .catch(({ errorFields, err }) => {
        // form.scrollToField(errorFields[0].name[0]);
        form.focusField(errorFields[0].name[0]);
        setSaveButtonLoading(false);
      });
  };

  // useKeyboardShortcuts("s", ["altKey"], () => onSubmit());
  EntryLevelKeys({ save: onSubmit });
  const [addLedgerResponse, setAddLedgerResponse] = useState<any>(null);

  useEffect(() => {
    if (addLedgerResponse) {
      const exists = payLedgers.some(
        (option: any) => option?.id === addLedgerResponse.id
      );
      if (exists) {
        form.setFieldValue("purPaymentLedger", addLedgerResponse?.id);
        setAddLedgerResponse(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payLedgers]);

  React.useEffect(() => {
    if (editAssetId) {
      setLoading(true);
      const getAssestDetails = async () => {
        let res = await FixedAssetsServiceNew?.getAssetDetails(
          currentClient?.id,
          // location?.state?.data?.id
          editAssetId
        );
        if (res.status) {
          setInvoiceDetail(res?.result?.invoiceDetail);
          setDepMethod(res?.result?.depMethod);
          setDepreciable(res?.result?.isDepreciable);
          setSingleAssetType(res?.result?.assetType === 0 ? true : false);
          form?.setFieldsValue({
            ...res?.result,
          });
          setLoading(false);
        } else {
          setLoading(false);
        }
      };
      getAssestDetails();
    }
  }, [editAssetId]);

  const handleAssetNameDuplicate = async (e: any) => {
    let ledDetail = assetsList?.filter(
      (led: any) => led.toLowerCase() === e?.target?.value.toLowerCase()
    );
    setAssetAvailable(ledDetail?.length! > 0 ? true : false);
  };

  const getAssetsList = async () => {
    const assetListRes = await FixedAssetsServiceNew.getParentAssetsList(
      currentClient?.id!
    );
    setAssetsList(assetListRes?.result);
  };
  useEffect(() => {
    getAssetsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns: ColumnsType<InvoiceDetail> = [
    {
      title: "S.No.",
      dataIndex: "key",
      key: "key",
      render: (val: string, _, index: number) => index + 1,
    },
    {
      title: "Purchase Date",
      dataIndex: "date",
      key: "date",
      render: (val: any) =>
        val !== undefined && dayjs(val).format("DD/MM/YYYY"),
    },
    {
      title: "Voucher Date",
      dataIndex: "voucherDate",
      key: "voucherDate",
      render: (val: any) =>
        val !== undefined && dayjs(val).unix() > 1
          ? dayjs(val).format("DD/MM/YYYY")
          : undefined,
    },
    {
      title: "Invoice Number",
      dataIndex: "invNumber",
      key: "invNumber",
      align: "center",
      render: (val: string) => val,
    },
    {
      title: "Total Amount",
      dataIndex: "totalValue",
      // key: "price",
      align: "right",
      render: (val: string) => Utils.getFormattedNumber(val),
    },
    {
      title: "Quantity",
      dataIndex: "qty",
      key: "qty",
      align: "center",
      render: (val: string) => val,
    },
    {
      title: "Payment Date",
      dataIndex: "purPayDate",
      key: "purPayDate",
      render: (val: string) =>
        val !== undefined && dayjs(val).unix() > 1
          ? dayjs(val).format("DD/MM/YYYY")
          : undefined,
    },
    {
      title: "Payment Method",
      dataIndex: "purPayMethod",
      key: "purPayMethod",
      align: "center",
      render: (val: any) =>
        val === PmtMethod.bank
          ? "Bank"
          : val === PmtMethod.cash
          ? "Cash"
          : val === PmtMethod.partialCredit
          ? "Partial Payment"
          : "Credit",
    },
    {
      title: "Action",
      dataIndex: "key",
      render: (val: any) => (
        <>
          <Button
            onClick={() => {
              setOpenModel({
                type: "AssestInvoiceModal",
                param: {
                  type: "edit",
                  selKey: val,
                },
              });
              // setPurchaseDetailCount(purchaseDetailCount + 1);
              // setSelIndex(undefined);
            }}
            icon={<EditOutlined />}
            size="small"
          />
          <Button
            style={{ marginLeft: "5px" }}
            onClick={() => {
              setVal(val);
              setConfirmation(true);
              // setInvoiceDetail((prevValues) => {
              //   let newValues = prevValues.filter((itm) => itm.key !== val);
              //   return newValues;
              // });
              // setSelIndex(undefined);
              // setPurchaseDetailCount(purchaseDetailCount - 1);
            }}
            icon={<DeleteOutlined style={{ color: "red" }} />}
            size="small"
          />
        </>
      ),
    },
  ];

  const fixedAssetDataModal = (
    <Row
      className="cardBody"
      style={{
        overflowY:
          location.pathname ==
          `/billing/clients/${currentClient?.id}/asset/addFixedAsset`
            ? "scroll"
            : "unset",
      }}
    >
      <Col span={24}>
        <Spin indicator={antIcon} spinning={loading}>
          <Form
            form={form}
            name="basic"
            disabled={loading}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            //style={{ maxWidth: 1000 }}
            autoComplete="off"
            requiredMark={false}
            layout="vertical"
            size="middle"
            //onFinishFailed={}
            // initialValues={{
            //   invoiceDetail: [{}],
            // }}
            initialValues={{
              assetType: 0,
              // group: {
              //   value: AssetsGroupOptions[0]?.value,
              //   label: AssetsGroupOptions[0]?.title,
              // }
              // group: [fixedAssetsGroups[0]?.value]
            }}
            // initialValues={editAsset?.id ? {} : initialValue}
          >
            <div className="inputboxmb">
              <Card size="small">
                <Row gutter={6}>
                  <Col lg={10} md={10}>
                    <Form.Item
                      name="name"
                      label="Asset Name"
                      rules={[
                        {
                          required: true,
                          message:
                            "Name required. Only alphanumeric characters with space, _, / and - are allowed.",
                          pattern:
                            /^[A-Za-z0-9_/()-]+(?:\s[A-Za-z0-9_/()-]+)*$/,
                        },
                        {
                          min: 3,
                          max: 30,
                          message:
                            "Required length is minimum 3 and maximum 30",
                        },
                        {
                          validator: (_) => {
                            if (assetAvailable) {
                              return Promise.reject("Name already exists.");
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                      className="inputboxmb"
                    >
                      <Input autoFocus onChange={handleAssetNameDuplicate} />
                    </Form.Item>
                  </Col>
                  <Col lg={4} md={4}>
                    <Form.Item
                      name="number"
                      label="Asset Reference"
                      className="inputboxmb"
                      rules={[
                        {
                          required: true,
                          message: "Number required",
                        },
                      ]}
                    >
                      <Input type="string" disabled />
                    </Form.Item>
                  </Col>

                  <Col lg={6} md={6}>
                    <Form.Item
                      name="assetType"
                      label="Asset Type"
                      className="inputboxmb"
                      rules={[
                        {
                          required: true,
                          message: "Type required",
                        },
                      ]}
                    >
                      <Select
                        onChange={(val) => {
                          val === 0
                            ? setSingleAssetType(true)
                            : setSingleAssetType(false);
                        }}
                        placeholder="Select asset type"
                        options={[
                          { value: 0, label: "Single", title: "" },
                          { value: 1, label: "Collective", title: "" },
                        ]}
                      />
                    </Form.Item>
                  </Col>

                  <Col lg={4} md={4}>
                    <Form.Item
                      name="isDepreciable"
                      valuePropName="checked"
                      style={{ display: "flex", flexDirection: "row" }}
                      labelCol={{ lg: 24 }}
                      wrapperCol={{ lg: 24 }}
                      className="inputboxmb"
                    >
                      <span>
                        Depreciable Asset
                        <br />
                        <Switch
                          style={{ margin: "10px 4px 0px" }}
                          checked={isDepreciable}
                          onChange={(isChecked) => {
                            setDepreciable(isChecked);
                          }}
                        />
                      </span>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={6}>
                  <Col lg={6} md={6}>
                    <Form.Item
                      name="group"
                      label="Asset Group"
                      rules={[
                        {
                          required: true,
                          message: "Please select group",
                        },
                      ]}
                      className="inputboxmb"
                    >
                      <TreeSelect
                        //className="inputboxsize"
                        treeNodeFilterProp="title"
                        showSearch
                        placeholder="Please select asset group"
                        allowClear
                        // value={groupValue}
                        //treeDefaultExpandAll
                        loading={groupDropdownloading}
                        style={{ marginBottom: "3px" }}
                        treeData={fixedAssetsGroups}
                        // onChange={onAssetGroupChange}
                        dropdownRender={(groupOptions) => (
                          <>
                            {groupOptions}
                            <Divider style={{ margin: "5px 0px" }} />
                            <Button
                              style={{ width: "100%" }}
                              icon={<PlusOutlined />}
                              type="link"
                              onClick={() =>
                                setOpenModel({
                                  type: "addGroup",
                                  param: "",
                                })
                              }
                            >
                              New Group
                            </Button>
                          </>
                        )}
                        dropdownStyle={{
                          maxHeight: 400,
                          overflow: "auto",
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={18} md={18}>
                    <Form.Item
                      name="description"
                      label="Description"
                      className="inputboxmb"
                      rules={[
                        {
                          min: 0,
                          max: 250,
                          message:
                            "Required length is minimum 0 and maximum 250",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Form.Item
                    name="attachments"
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                      return e.fileList;
                    }}
                    // className="m-0"
                    style={{ paddingTop: "10px", margin: "0px" }}
                  >
                    <Upload
                      multiple
                      maxCount={5}
                      accept={".png, .jpg, .jpeg, .pdf"}
                      beforeUpload={() => {
                        return false;
                      }}
                      onRemove={(e: any) => {
                        if (editAssetId && e?.id) {
                          setDeleteUploadId([...deleteUploadId, e?.id]);
                        }
                      }}
                      onPreview={(e: any) => {
                        if (editAssetId && e?.path) {
                          setPreviewImage({
                            isBaseConvert: false,
                            path: e,
                          });
                        } else if (e.type?.split("/")[0] === "image") {
                          setPreviewImage({
                            isBaseConvert: true,
                            path: e,
                          });
                        }
                      }}
                    >
                      <Button
                        icon={<UploadOutlined />}
                        style={{ backgroundColor: "ButtonFace" }}
                      >
                        Uploads
                      </Button>
                    </Upload>
                  </Form.Item>
                </Row>
              </Card>
              {isDepreciable && (
                <>
                  <Card
                    title="Depreciation Detail"
                    size="small"
                    style={{ marginTop: "10px" }}
                  >
                    <Row gutter={6}>
                      <Col lg={16} md={16}>
                        <Form.Item
                          name="category"
                          label="Asset Category"
                          rules={[
                            {
                              required: true,
                              message: "Asset category is mandatory",
                            },
                          ]}
                          className="inputboxmb"
                        >
                          <TreeSelect
                            //className="inputboxsize"
                            treeNodeFilterProp="title"
                            showSearch
                            placeholder="Please select asset category"
                            allowClear
                            value={categoryValue}
                            treeDefaultExpandAll
                            style={{ marginBottom: "3px" }}
                            treeData={AssetCategoryOptions}
                            onChange={(cat: string) =>
                              onAssetCategoryChange(cat)
                            }
                            dropdownStyle={{
                              maxHeight: 400,
                              overflow: "auto",
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={6} md={6}>
                        <Form.Item
                          name="depMethod"
                          label="Depreciation Method"
                          rules={[
                            {
                              required: true,
                              message: "Please select depreciation method",
                            },
                          ]}
                          className="inputboxmb"
                        >
                          <Select
                            //className="inputboxsize"
                            style={{ marginBottom: "3px" }}
                            onChange={(val) => onAssetDepMethodChange(val)}
                            placeholder="Please select depreciation method"
                            //defaultValue={CalcMethod.WrittenDownValue}
                            options={[
                              {
                                value: CalcMethod.StraightLine,
                                label: "Straight Line Method",
                                title: "",
                              },
                              {
                                value: CalcMethod.WrittenDownValue,
                                label: "Written Down Method",
                                title: "",
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={4} md={4}>
                        <Form.Item
                          name="lifeCycleDuration"
                          label="Asset Life in year"
                          className="inputboxmb"
                          rules={[
                            {
                              required:
                                depMethod === CalcMethod.StraightLine
                                  ? true
                                  : false,
                              message: "Asset life required",
                              pattern: /^[ A-Za-z0-9_/(/)-]*$/,
                            },
                          ]}
                        >
                          <InputNumber
                            min={0}
                            max={100}
                            precision={0}
                            style={{ width: "100%" }}
                            onFocus={(e: any) => handleInputFocus(e, form)}
                            onBlur={(val: any) =>
                              handleSLMDepRate(val?.target?.value)
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={4} md={4}>
                        <Form.Item
                          name="depRate"
                          label="Depreciation Rate"
                          rules={[
                            {
                              required: true,
                              message: "Please input depreciation rate",
                            },
                          ]}
                          className="inputboxmb"
                        >
                          <InputNumber
                            style={{ width: "100%" }}
                            min={0}
                            max={100}
                            onFocus={(e: any) => handleInputFocus(e, form)}
                            type="number"
                            // onKeyPress={(e: any) => {
                            //   if (!/\d|\./.test(e.key)) e.preventDefault();
                            //   if (e.key === "." && e.target.value.includes("."))
                            //     e.preventDefault();
                            // }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                </>
              )}

              <Card
                title="Purchase Detail"
                size="small"
                style={{ marginTop: "10px" }}
              >
                <Row>
                  {((invoiceDetaildata.length < 1 && singleAssetType) ||
                    !singleAssetType) && (
                    <>
                      {" "}
                      <Col span={24}>
                        <Button
                          type="link"
                          onClick={() => {
                            form
                              .validateFields()
                              .then(() => {
                                setOpenModel({
                                  type: "AssestInvoiceModal",
                                  param: {
                                    type: "add",
                                    selKey:
                                      invoiceDetaildata.length > 0
                                        ? invoiceDetaildata?.length
                                        : 0,
                                  },
                                });
                              })
                              .catch(({ errorFields, err }) => {
                                // form.scrollToField(errorFields[0].name[0]);
                                form.focusField(errorFields[0].name[0]);
                              });
                          }}
                          style={{ marginBottom: "10px" }}
                        >
                          <PlusCircleOutlined /> Add Purchase Detail
                        </Button>
                      </Col>
                    </>
                  )}
                  <Col span={24}>
                    <Table
                      columns={columns}
                      dataSource={invoiceDetaildata}
                    ></Table>
                  </Col>
                </Row>
              </Card>
            </div>
          </Form>
        </Spin>
      </Col>
    </Row>
  );
  React.useEffect(() => {
    if (addGroupVal) {
      form.setFieldValue("group", addGroupVal?.id);
    }
  }, [addGroupVal]);
  const [open, setOpen] = React.useState<any>(true);

  return (
    <div style={{ width: "100%", height: "100%" }}>
      {open && (
        <Card
          size="small"
          bordered={
            location.pathname ==
            `/billing/clients/${currentClient?.id}/asset/addFixedAsset`
              ? true
              : false
          }
          className="TableCard"
          style={{
            overflowY: "scroll",
            height: "calc(100vh - 100px)",
            boxShadow:
              location.pathname ==
              `/billing/clients/${currentClient?.id}/asset/addFixedAsset`
                ? "0px 0px 10px 0px #96A1C84D"
                : "none",
            backgroundColor:
              location.pathname ==
              `/billing/clients/${currentClient?.id}/asset/addFixedAsset`
                ? "white"
                : "transparent",
          }}
          title={
            <div style={{ padding: "10px" }}>
              <h3>{editAssetId ? "Update Asset" : "Add Asset"}</h3>
            </div>
          }
          extra={
            <div>
              <Button
                size="middle"
                onClick={onSubmit}
                type="primary"
                loading={saveButtonLoading}
              >
                Save Asset
              </Button>

              <Button
                size="middle"
                onClick={
                  location.pathname ==
                  `/billing/clients/${currentClient?.id}/asset/addFixedAsset`
                    ? () => navigate(-1)
                    : () => setOpenAssetModal(false)
                }
                style={{ marginLeft: "10px" }}
              >
                Cancel
              </Button>
            </div>
          }
        >
          {fixedAssetDataModal}
        </Card>
      )}
      {openModel.type === "AssestInvoiceModal" && (
        <AssetInvoiceDetail
          open={true}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          singleAssetType={singleAssetType}
          isDepreciable={isDepreciable}
          depMethod={depMethod}
          refNumber={form.getFieldValue("number")}
          setInvoiceDetail={setInvoiceDetail}
          selKey={openModel?.param?.selKey}
          oldPurchaseType={oldPurchaseType}
          assetName={form.getFieldValue("name")}
          assetId={editAssetId}
          invoiceDetaildata={
            openModel?.param?.type === "add"
              ? invoiceDetaildata?.length !== 0
                ? {
                    key: invoiceDetaildata?.length,
                    lifeCycleDuration: form.getFieldValue("lifeCycleDuration"),
                    taxCredit: ITCEligibility_Type.Available,
                  }
                : singleAssetType
                ? {
                    key: 0,
                    lifeCycleDuration: form.getFieldValue("lifeCycleDuration"),
                    taxCredit: ITCEligibility_Type.Available,
                    // childAssetDetail: [
                    //   {
                    //     childAssetName: form.getFieldValue("name"),
                    //   },
                    // ],
                  }
                : {
                    key: 0,
                    lifeCycleDuration: form.getFieldValue("lifeCycleDuration"),
                    taxCredit: ITCEligibility_Type.Available,
                  }
              : {
                  ...invoiceDetaildata.find(
                    (inv: any) => inv.key === openModel?.param?.selKey
                  ),
                  prevTotalPrice: invoiceDetaildata.find(
                    (inv: any) => inv.key === openModel?.param?.selKey
                  )?.totalValue,
                  lifeCycleDuration: form.getFieldValue("lifeCycleDuration"),
                }
          }
        />
      )}

      {/* {previewImage.path && (
        <DocumentPreview
          open={true}
          onCancel={() =>
            setPreviewImage({
              path: "",
              isBaseConvert: false,
            })
          }
          documentDetails={previewImage}
        />
      )} */}

      {openModel.type === "addGroup" && (
        <AddGroup
          open={true}
          editData={openModel?.param}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          setTrigger={() => setGroupListTrigger(!groupListTrigger)}
          groupData={fixedAssetsGroups}
          type={SearchLedgerByGroupsTypes.FixedAssets}
          showName={"Asset Group"}
          setAddGropVal={setAddGropVal}
        />
      )}

      {/* 
      {openModel.type === "addLedger" && (
        <AddLedger
          openDrawer={true}
          id={""}
          setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
          setTrigger={() =>
            onPaymentModeChange(form.getFieldValue("payMethod"))
          }
          setAddLedgerResponse={setAddLedgerResponse}
        />
      )} */}

      {confirmation && (
        <ConfirmationModal
          open={confirmation}
          text="Do you really want to delete this row?"
          onNo={() => setConfirmation(false)}
          onYes={() => {
            setInvoiceDetail((prevValues) => {
              let newValues = prevValues.filter((itm: any) => itm.key !== val);
              setConfirmation(false);
              return newValues;
            });
          }}
        />
      )}
    </div>
  );
};

export default AssetModel;
